import ModuleCarousel from './ModuleCarousel';

export default ModuleCarousel;
export * from './ModuleCarousel';
